import React from 'react';

import ModalVideo from 'react-modal-video';
import Popup from '../../Popup';
import styles from './welcomePopUps.scss';

class CollegeClubIntroPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoIsOpen: false,
            currentVideoId: '',
        };
    }

    render() {
        const {
            onCloseClick,
            onCtaClick,
        } = this.props;

        return (
            <Popup
                className={`popup-md`}
                popUpClassName={`${styles.welcomePopUp}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4>
                        Welcome to your new College Profile!
                        <span className="d-block">
                            Engage recruits and your community with a photo gallery
                        </span>
                    </h4>
                </div>
                <div className={`${styles.section} pt0`}>
                    <p>
                        Show off your tennis program with custom backgrounds and a photo gallery. Upgrade to UTR Sports College to host UTR Sports events and camps, and to access player research tools.
                    </p>
                    <div className={`${styles.tip}`}>
                        <span
                            className={`cursor-pointer`}
                            onClick={() => {
                                this.setState({
                                    videoIsOpen: true,
                                    currentVideoId: 'kaSmKsDNnRc',
                                });
                            }}
                        >
                            <i className="fas fa-play" /><span>Watch intro video</span>
                        </span>
                    </div>
                    <div className="bb" />
                    <button
                        type="button"
                        className="btn btn-primary btn-xl btn-block text-uppercase"
                        onClick={onCtaClick}
                    >
                        Got It
                    </button>
                </div>
                <ModalVideo
                    channel="youtube"
                    isOpen={this.state.videoIsOpen}
                    videoId={this.state.currentVideoId}
                    autoplay={true}
                    onClose={() => {
                        this.setState({
                            videoIsOpen: false,
                            currentVideoId: '',
                        });
                    }}
                />
            </Popup>
        );
    }
}

export default CollegeClubIntroPopUp;
